<template>
  <div class="jira-cloud-step-2">

    <div class="row">
      <div class="col-12">
        <h2>Issue Type Mapping</h2>
      </div>
    </div>

    <div class="row jira-feature-headline jf-row">
      <div class="col-5">
        <div class="jfh-col metastory">

          <div class="icon">
            <img class="metastory-logo light" src="@/assets/ui/text-cursor.svg" style="width: 6px;">
            <img class="metastory-logo dark" src="@/assets/ui/text-cursor-white.svg" style="width: 6px;">
          </div>
          metastory AI Types
        </div>
      </div>
      <div class="col-2 icon-snyc">

      </div>
      <div class="col-5">
        <div class="jfh-col jira">
          <div class="icon">
            <img src="@/assets/integrations/jira.svg" style="height: 16px;">
          </div>
          Issue Types
        </div>
      </div>
    </div>

    <div class="row jira-feature-form jf-row">
      <div class="col-5">
        <div class="fp-label">
          <span class="icon">
            <div class="color"></div>
          </span>
          <span>Group</span>
        </div>
      </div>
      <div class="col-2 icon-snyc">
        <LucideIcon icon="Link"/>
      </div>
      <div class="col-5">
        <FieldSkeletonComponent v-if="jiraEpicActions.length === 0"/>
        <JiraMultipleSelectDropdownElement
            v-else
            v-model="selectedEpics"
            :options="jiraEpicActions"
            title="Multiple Select"
        >
        </JiraMultipleSelectDropdownElement>
      </div>
    </div>

    <div class="row jira-feature-form jf-row">
      <div class="col-5">
        <div class="fp-label">
          <span class="icon"><LucideIcon icon="FileText"/></span>
          <span>Feature</span>
        </div>
      </div>
      <div class="col-2 icon-snyc">
        <LucideIcon icon="Link"/>
      </div>
      <div class="col-5">
        <FieldSkeletonComponent v-if="jiraTaskActions.length === 0"/>
        <JiraMultipleSelectDropdownElement
            v-else
            v-model="selectedTasks"
            :options="jiraTaskActions"
            title="Multiple Select"
        >
        </JiraMultipleSelectDropdownElement>
      </div>
    </div>

    <div class="row jira-feature-form jf-row">
      <div class="col-5">
        <div class="fp-label">
          <span class="icon"><LucideIcon icon="FileText"/></span>
          <span>Subfeature</span>
        </div>
      </div>
      <div class="col-2 icon-snyc">
        <LucideIcon icon="Link"/>
      </div>
      <div class="col-5">
        <FieldSkeletonComponent v-if="jiraSubTaskActions.length === 0"/>
        <JiraMultipleSelectDropdownElement
            v-else
            v-model="selectedSubTasks"
            :options="jiraSubTaskActions"
            title="Multiple Select"
        >
        </JiraMultipleSelectDropdownElement>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="config-footer flex-end">
          <div class="button-group">
            <ButtonElement class="btn--ms btn--silent-tertiary btn--regular" @click="$emit('cancelClick')">Back</ButtonElement>
            <ButtonElement class="btn--ms btn--accent" @click="clickContinue()"
                           :is-disable="selectedEpics.length === 0 || selectedTasks.length === 0 || selectedSubTasks.length === 0">
              Continue
            </ButtonElement>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import ButtonElement from '@shared/components/elements/button/button.element.vue'
import FieldSkeletonComponent from '@domains/settings/views/integrations/field-skeleton.component.vue'
import {type DropdownNs, FeatureNs, IntegrationNs, } from '@shared/types'
import {mapStores} from "pinia";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useIntegrationStore} from "@domains/settings/stores/integration.store";
import {JiraMultipleSelectDropdownElement} from "@shared/components";
import {useGeneralStore} from "@shared/stores/general.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'JiraCloudStep3',
  components: {
    ButtonElement,
    JiraMultipleSelectDropdownElement,
    FieldSkeletonComponent
  },
  emits: ['cancelClick', 'continueClick'],
  props: {
    selectedProjectKey: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapStores(useWorkspaceStore, useIntegrationStore, useGeneralStore),
  },
  data() {
    return {
      intIssueTypes: [] as IntegrationNs.IntIssueType[],
      jiraEpicActions: [] as DropdownNs.DropdownOptionsItem[],
      jiraTaskActions: [] as DropdownNs.DropdownOptionsItem[],
      jiraSubTaskActions: [] as DropdownNs.DropdownOptionsItem[],

      selectedEpics: [] as DropdownNs.DropdownOptionsItem[],
      selectedTasks: [] as DropdownNs.DropdownOptionsItem[],
      selectedSubTasks: [] as DropdownNs.DropdownOptionsItem[]

    }
  },
  beforeMount() {
    const payload = {
      workspaceId: this.workspaceStore.getSelectedWorkspaceId,
      integrationType: 'JIRA',
      projectKey: this.selectedProjectKey
    } as IntegrationNs.GetIssueTypeRequest

    this.integrationStore.loadIssueTypes(payload)
        .then((data) => {
          this.intIssueTypes = data
          if (data && data.length > 0) {
            this.intIssueTypes.forEach((issueType) => {
              if (issueType.hierarchyLevel === 1) {
                this.jiraEpicActions.push({
                  name: issueType.name,
                  svg: `${issueType.iconUrl}`,
                  value: `${issueType.id}`
                })
              }
              if (issueType.hierarchyLevel === 0) {
                this.jiraTaskActions.push({
                  name: issueType.name,
                  svg: `${issueType.iconUrl}`,
                  value: `${issueType.id}`
                })
              }
              if (issueType.hierarchyLevel === -1) {
                this.jiraSubTaskActions.push({
                  name: issueType.name,
                  svg: `${issueType.iconUrl}`,
                  value: `${issueType.id}`
                })
              }
            })
          } else {
            toast.error("Unable to read Issue Types from the project. Please try again");
            this.$emit('cancelClick');
          }
        })
  },
  methods: {
    clickContinue() {
      if (this.selectedEpics.length === 0 || this.selectedTasks.length === 0 || this.selectedSubTasks.length === 0) {
        return
      }

      const groupSelection = this.intIssueTypes.filter((type) => this.selectedEpics.map((item) => item.value).includes(type.id))
      const featureSelection = this.intIssueTypes.filter((type) => this.selectedTasks.map((item) => item.value).includes(type.id))
      const subFeatureSelection = this.intIssueTypes.filter((type) => this.selectedSubTasks.map((item) => item.value).includes(type.id))

      const groupMapping = groupSelection.map((type) => {
        return {
          featureType: FeatureNs.FeatureTypeEnums.GROUP,
          issueTypeId: type.id,
          issueTypeName: type.name
        } as IntegrationNs.IntIssueTypeMapping
      })

      const featureMapping = featureSelection.map((type) => {
        return {
          featureType: FeatureNs.FeatureTypeEnums.FEATURE,
          issueTypeId: type.id,
          issueTypeName: type.name
        } as IntegrationNs.IntIssueTypeMapping
      })

      const subFeatureMapping = subFeatureSelection.map((type) => {
        return {
          featureType: FeatureNs.FeatureTypeEnums.SUB_FEATURE,
          issueTypeId: type.id,
          issueTypeName: type.name
        } as IntegrationNs.IntIssueTypeMapping
      })

      const issueMatching = {
        GROUP: groupMapping,
        FEATURE: featureMapping,
        SUB_FEATURE: subFeatureMapping
      }

      this.$emit('continueClick', issueMatching)
    }
  }
})
</script>

<style lang="scss" scoped>
.jf-row {
  .col-5 {
    flex: 0 0 auto;
    width: 48%;
  }

  .col-2 {
    flex: 0 0 auto;
    width: 2.66667%;
  }
}

h2{
  margin-bottom: var(--space-32);
}

.jira-feature-form {
  min-height: 44px;
  margin-bottom: var(--space-8);

  .icon-snyc {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--fs-14);
    color: var(--neutral-200);
    height: 44px;
  }

  .fp-label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 44px;
    border-radius: $br-sm;
    font-size: var(--fs-14);
    color: var(--grey-color--900);
    background: var(--light-300);
    border: 1px solid var(--light-300);

    .color {
      width: 14px;
      height: 14px;
      border-radius: $br-xs;
      background-color: var(--text-neutral);
    }

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 44px;
      color: var(--text-neutral);
    }
  }
}

</style>
